<template>
  <div class="print_check" :class="{loading_container: loading}">
    <div v-if="loading" class='loading'>
      <img src="/files/imgs/loading.svg" />
    </div>

    <h3>Print Check</h3>
    <h4>{{ state }}</h4>
    <div v-if="state==='Confirm Account'">
      <form @submit.prevent="confirm_account()">
	<accounts :items='checking_accounts' v-model='checking' :types='checking_types' :required='true' /><button type="submit">Confirm</button>
      </form>
    </div>
    <div v-if="state==='Enter Check #' || state==='Reprint'">
      <form @submit.prevent="check_number()">
	Check # <input required type="text" maxlength="256" v-model="check_num" placeholder="Check #" style="width: 200px" /><button type="submit">Confirm</button>
      </form>
      <p>Account: {{ account_name }}</p>
    </div>
    <div v-if="state==='Load Check In Printer'">
      <p><form @submit.prevent="record_and_print()"><button type="submit">Record and Print</button></form></p>
      <p><em>When printing, make sure to set margins to None and set paper size to 8.5"x11"</em></p>
      <div class="page" style="background-image: url('/files/books/imgs/check_usd.png'); background-size: cover;" ref="page">
	<div class='third'>
	  <div class='check_num'>Check #: {{check_num}}</div>
          <div class="date">{{ moment(entry.date).format("ll") }}</div>
          <div class="pay_to">{{company.name}}</div>
          <div class="amount">**{{$store.getters.raw_to_amt(-payment.amount, payment.currency)}}**</div>
          <div class="amount_as_words">{{amount_as_words}}</div>
          <div class="memo">{{entry.memo}}</div>
          <div class='address'>
            <div class="pay_to2">{{company.name}}</div>
            <div class="attn">{{company.firstname}} {{company.lastname}}</div>
            <div class="addr">{{company.address}}</div>
            <div class="city_state_zip">{{company.city}} {{company.state}} {{company.zip}}</div>
          </div>
	</div>
	<div v-for="idx in [2,3]" class='third stub'>
          <div>Pay To: {{company.name}}</div>
	  <div>Date: {{ moment(entry.date).format("ll") }}</div>
	  <div>Check #: {{check_num}}</div>
          <div>Amount: {{$store.getters.raw_to_amt(-payment.amount, payment.currency)}} {{ payment.currency }}</div>
          <div>Memo: {{entry.memo}}</div>
          <div>Contact: {{company.first_name}} {{company.last_name}} {{company.email}} {{company.phone}}</div>
          <table>
            <tr><th></th><th>Description</th><th>Amount</th></tr>
            <tr v-for="li, idx in line_items">
              <td>{{ idx+1 }}.</td>
              <td>{{ li.name }}</td>
              <td class='td_num'>{{ $store.getters.raw_to_amt(li.amount, li.currency) }}</td>
            </tr>
          </table>
	</div>
      </div>
    </div>
  </div>

</template>

<script>
import Editable from '@/components/Editable.vue'
import Accounts from '@/components/Accounts.vue'
import Num2Words from 'number-to-words'

export default {
    components : {
	Editable, Accounts
    },
    computed: {
	amount_as_words: function() {
	    var n = this.$store.getters.raw_to_amt(-this.payment.amount, this.payment.currency);
	    var x = Num2Words.toWords(n)
	    var decimal = n.slice(-2)
	    var y = "**" + x.charAt(0).toUpperCase() + x.slice(1) + " dollars and " + decimal + "/100**"
	    return y
	}
    },
    props: {
	pk                : Number,
	checking_accounts : Array,
	checking_types    : Array,
    },
    data: function() { return {
	loading : false,
	entry   : null,
	payment : null,
	state   : "Initializing...",
	checking: null,
	check_num: "",
	account_name : "",
	company : null,
	line_items: [],
    }},
    methods: {
	confirm_account: function() {
	    if(this.checking == this.payment.account_id) {
		this.account_name = this.checking_accounts.find(a => a.id == this.checking).name
		this.state = "Enter Check #"
	    } else {
		var self = this
		self.rpc("books","Outgoing","change_account", { entry_id: self.entry.id, account_id: this.checking }, "Changing Account")
		    .then(function(data) {
			self.payment = data.payment
			self.confirm_account()
		    })
		    .catch(function(error) {
			self.$store.commit('showError', error)
		    })
	    }
	},
	check_number: function() {
	    this.state = "Load Check In Printer"
	},
	record_and_print: function() {
	    var check = this.$refs.page.cloneNode(true)
	    var self = this
	    self.loading = true
	    self.rpc("books","Outgoing","record_and_print", { id: self.entry.id, check_num: self.check_num }, "__bg__")
		.then(function(data) {
		    self.$emit("updateentry", data)
		    self.entry = data.entry
		    self.loading = false
		    self.$store.dispatch('print', check)
		    self.state = "Reprint"
		})
		.catch(function(error) {
		    self.loading = false
		    self.$store.commit('showError', error)
		})
	}
    },
    mounted: function() {
        var self=this
	self.loading = true
        self.rpc("books","Outgoing","get_for_print", {id: self.pk}, "__bg__")
            .then(function(data) {
		self.entry = data.entry
		self.payment = data.payment
		self.company = data.company
		self.checking = data.payment.account_id
		self.line_items = data.line_items
		if(self.entry.status === 4) {
		    self.state = "Reprint"
		    self.check_num = self.payment.doc_num
		    self.checking = self.payment.account_id
		    self.account_name = self.checking_accounts.find(a => a.id == self.checking).name
		} else {
		    self.state = "Confirm Account"
		}
		self.loading = false
            })
            .catch(function(error) {
		self.loading = false
                self.$store.commit('showError', error)
            })
    }
    
}
  
</script>

<style scoped>

.print_check {
    padding: 15px 15px 40px 15px;
}
.print_check.loading_container {
    position: relative;
}
.loading {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(255,255,255,0.5);
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loading img {
    width: 32px;
}
.page {
    width   : 8.5in;
    height  : 11in;
    outline : 1px solid black;
    overflow: hidden;
    margin  : 0;
    padding : 0;
}
.third {
    width   : 100%;
    box-sizing: border-box;
    height  : 3.666in;
    margin  : 0;
    padding : 0;
    position: relative;
    overflow: hidden;
}
.check_num, .date, .pay_to, .amount, .amount_as_words, .memo, .address {
    position: absolute;
}
.check_num {
    top: 0.25in;
    right: 1in;
}
.date {
    top: 0.75in;
    left: 6.9in;
}
.pay_to {
    top: 1.27in;
    left: 1.2in;
}
.amount {
    top: 1.3in;
    left: 7in;
}
.amount_as_words {
    top: 1.6in;
    left: 0.5in;
}
.address {
    top: 1.95in;
    left: 1in;
    font-size: 0.9em;
}
.memo {
    top: 2.8in;
    left: 0.7in;
    max-width: 4.5in;
    max-height:0.39in;
    overflow: hidden;
    font-size: 0.9em;
}
table {
    border-collapse: collapse;
}
tr {
    background-color: inherit !important;
}
.stub {
    padding-left: 0.5in;
}
@media print {
    .check_num {
	display: none;
    }
}
</style>
